export default {
    methods: {
        convertCurrentValue(value) {
            return Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(value)
        },
        convertDecimalValue(value) {
            return Intl.NumberFormat('pt-BR', {
                style: 'decimal',
            }).format(value)
        },

        convertDate(v) {
            if (v) {
                v = v.replace("-", "").replace("-", "");
                let year = v.substring(0, 4);
                let month = v.substring(4, 6);
                let day = v.substring(6, 8);
                return `${day}/${month}/${year}`;
            } else {
                return false;
            }
        },
        convertDateTime(v) {
            if (v) {
                if (typeof v === 'string' && (v.includes('T') || v.includes('-'))) {
                    const date = new Date(v);
                    if (!isNaN(date.getTime())) {
                        const day = String(date.getDate()).padStart(2, '0');
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const year = date.getFullYear();
                        const hour = String(date.getHours()).padStart(2, '0');
                        const min = String(date.getMinutes()).padStart(2, '0');
                        return `${day}/${month}/${year} ${hour}:${min}`;
                    }
                }
                v = String(v).replace('-', '').replace('-', '');
                let year = v.substring(0, 4);
                let month = v.substring(4, 6);
                let day = v.substring(6, 8);
                let hour = v.substring(9, 11);
                let min = v.substring(12, 14);
                return `${day}/${month}/${year} ${hour}:${min}`;
            } else {
                return false;
            }
        },
        calcValue() {
            if (
                parseFloat(this.data.item_price) > 0 &&
                parseFloat(this.data.item_amount) > 0
            ) {
                this.data.item_total_bidding_price =
                    parseFloat(this.convertDecimalNumber(this.data.item_price)) *
                    parseFloat(this.data.item_amount);
            }
        },
        convertDecimalNumber(n) {
            let number = n;
            number = number
                .replace(",", "")
                .replace(".", "")
                .replace(".", "");
            return number;
        },
        convertDecimalNumberII(n) {
            let number = n;
            if (typeof number !== 'string') number = String(number || "");
            number = number
                .replace(",", ".")
            return number;
        },
        convertDecimalNumberIII(n) {
            let number = n;
            number = number.replace(/\./g, ""); //retira o ponto do valor entrado
            number = number.replace(",", "."); //troca a vírgula por 
            return number;
        },
        realMask(value) {
            if (typeof value !== "string") value = String(value || "");
            if (value && parseFloat(value) > 0) {
                value = value.replace(/\D/g, ""); // permite digitar apenas numero
                value = value.replace(/(\d{1})(\d{14})$/, "$1.$2"); // coloca ponto antes dos ultimos digitos
                value = value.replace(/(\d{1})(\d{11})$/, "$1.$2"); // coloca ponto antes dos ultimos 11 digitos
                value = value.replace(/(\d{1})(\d{8})$/, "$1.$2"); // coloca ponto antes dos ultimos 8 digitos
                value = value.replace(/(\d{1})(\d{5})$/, "$1.$2"); // coloca ponto antes dos ultimos 5 digitos
                value = value.replace(/(\d{1})(\d{1,2})$/, "$1,$2"); // coloca virgula antes dos ultimos 2 digitos
                return value;
            } else {
                return '0,00';
            }
        },
        realMaskII(value) {
            if (typeof value !== "string") value = String(value || "");
            if (value && parseFloat(value) > 0) {
                value = value.replace(/\D/g, ""); // permite digitar apenas numero
                value = value.replace(/(\d{1})(\d{15})$/, "$1.$2"); // coloca ponto antes dos ultimos digitos
                value = value.replace(/(\d{1})(\d{12})$/, "$1.$2"); // coloca ponto antes dos ultimos 11 digitos
                value = value.replace(/(\d{1})(\d{9})$/, "$1.$2"); // coloca ponto antes dos ultimos 8 digitos
                value = value.replace(/(\d{1})(\d{6})$/, "$1.$2"); // coloca ponto antes dos ultimos 5 digitos
                value = value.replace(/(\d{1})(\d{3})$/, "$1,$2"); // coloca virgula antes dos ultimos 3 digitos
                return value;
            } else {
                return '0,000';
            }
        },
        formatDateBr(date) {
            return date
                .substr(0, 10)
                .split("-")
                .reverse()
                .join("/");
        },

        checkAuth() {
            if (sessionStorage.getItem("token")) {
                this.$router.push("/dashboard");
            } else {
                this.$router.push("/login");
            }
        },

        formatarStringData2(date) {
            if (date) {
                const dia = date.substring(0, 2);
                const mes = date.substring(3, 5);
                const ano = date.substring(6, 10);
                const hour = date.substring(11, 13);
                const minutes = date.substring(14, 16);
                return `${ano}-${mes}-${dia} ${hour}:${minutes}:00`;
            }
        },

        convertStringNumber(value) {
            if (value && typeof value === 'string') {
                const newValue = value.replace(/\./g, "").replace(",", ".");
                return Number(newValue);
            }
            return Number(value || 0);
        },

        round2(v) {
            return Math.round(v * 100) / 100;
        },
        printReport() {
            window.print();
        },
        getCurrentDateTimeBr() {
            const date = new Date();
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hour = String(date.getHours()).padStart(2, '0');
            const min = String(date.getMinutes()).padStart(2, '0');
            return `${day}/${month}/${year} ${hour}:${min}`;
        }
    }
}